var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getDetailSlice = {
    getDetailCampaignRequest: function (state) { return (__assign(__assign({}, state), { pending: true })); },
    getDetailCampaignSuccess: function (state, action) { return (__assign(__assign({}, state), { pending: false, getDetailCampaignResponse: action.payload.getDetailCampaignResponse, error: null })); },
    getDetailCampaignFailed: function (state, action) { return (__assign(__assign({}, state), { pending: false, error: action.payload.error })); },
};
